import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Components Import
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Products from './components/Products';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Privacyinfo from './components/Privacyinfo'; // तुमची फाईल

// Theme Configuration
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#1e90d4' },
    secondary: { main: '#f0c040' },
    background: { default: '#081e35', paper: '#0d2847' },
    text: { primary: '#e8f0fe', secondary: '#8fb3d9' },
  },
  typography: {
    fontFamily: '"DM Sans", sans-serif',
    h1: { fontFamily: '"Playfair Display", serif', fontWeight: 900 },
    h2: { fontFamily: '"Playfair Display", serif', fontWeight: 700 },
    h3: { fontFamily: '"Playfair Display", serif', fontWeight: 700 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '2px',
          textTransform: 'none',
          fontWeight: 600,
          letterSpacing: '0.5px',
          fontSize: '0.95rem',
        },
      },
    },
  },
});

// Home Page Layout (सगळे सेक्शन्स एका खाली एक)
const Home = () => {
  return (
    <>
       <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar />
      <Hero />
      <Services />
      <WhyUs />
      <Products />
      <Testimonials />
      <Contact />
      
    </ThemeProvider>
    </>
  );
};

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Navbar आणि Footer प्रत्येक पेजवर दिसणार */}
        <Navbar />
        
        <Routes>
          {/* मुख्य पानाचा मार्ग */}
          <Route path="/" element={<Home />} />
          
          {/* Privacy Policy पानाचा मार्ग */}
          <Route path="/privacy-policy" element={<Privacyinfo />} />
        </Routes>

        <Footer />
      </Router>
    </ThemeProvider>
  );
}